'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _changespercoder = require('./changespercoder.html');

var _changespercoder2 = _interopRequireDefault(_changespercoder);

var _changespercoder3 = require('./changespercoder.controller');

var _changespercoder4 = _interopRequireDefault(_changespercoder3);

require('./changespercoder.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changespercoderComponent = {
  restrict: 'E',
  bindings: {},
  template: _changespercoder2.default,
  controller: _changespercoder4.default,
  controllerAs: 'vm'
};

exports.default = changespercoderComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/changespercoder/changespercoder.component.js